import { RosterTable } from "../components/chw/RosterTable";

/**
 * §14: the roster below is illustrative sample data, hand-authored in
 * demo/chwRoster.ts — never fetched, generated, or varying at runtime.
 * This banner is the honesty disclosure required by §21 item 12: it must
 * never be possible to mistake the sample rows for real records. The one
 * row bound to real data — the live row, labeled "This device — live" in
 * the table below — reflects the actual in-memory interview state.
 *
 * What this banner must NOT say (§21 item 13): that nothing is stored or that
 * data never leaves the browser. Both are broader than Fieldnote can assert —
 * every turn goes to the Fieldnote server, and in Live Mode to the model
 * provider; the accurate statement lives in the governance panel. It also must
 * not suggest a hand-off: no roster, assignment or messaging exists, so the
 * banner says outright that this view contacts no one. (Until 2026-10-08 it said
 * "no participant data is stored", which broke the first of those rules.)
 */
export function ChwView() {
  return (
    <div className="flex h-full flex-col gap-4 overflow-y-auto p-4">
      <div className="rounded-lg border border-border bg-paper-dim p-3 text-sm text-ink-soft">
        <h2 className="font-medium text-ink">This roster is illustrative sample data.</h2>
        <p className="mt-1">
          The families below are fictional and hand-authored for this demo, and nothing here is
          fetched or generated from a real interview. This view does not notify, assign, or contact
          anyone. The one row marked "This device — live" reflects the actual check-in currently
          running in this browser tab, if any.
        </p>
      </div>
      <RosterTable />
    </div>
  );
}
